import { render, staticRenderFns } from "./ProductsRow.vue?vue&type=template&id=40dfadcb&"
import script from "./ProductsRow.vue?vue&type=script&lang=js&"
export * from "./ProductsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports